import { CommonService, ServiceHistoryCheckTypeModel } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_TYPES_QUERY_KEY = 'ServiceHistoryTypesQuery';

const fetchServiceHistoryTypes = async () => {
  const result = await CommonService.getCommonServiceHistoryTypes();
  return result;
};

export const useServiceHistoryTypesQuery = () =>
  useQuery<ServiceHistoryCheckTypeModel[]>([SERVICE_HISTORY_TYPES_QUERY_KEY], fetchServiceHistoryTypes);
